"use client"

import React, { useState, useEffect, useRef } from 'react';

import DataTableListGenerica from '../DataTableListGenerica/DataTableListGenerica'
import { Skeleton } from 'primereact/skeleton';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';

import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import AuthStorage from '../../storage/AuthStorage';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';

import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';

const Document = React.forwardRef((props, ref) => {

    const fileUploadRef = useRef(null);
    const genericaSistemaService = new GenericaSistemaService();
    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();
    const { userName, idEmpresa, idioma } = userDetails;
    const [mensajeError, setMensajeError] = useState("");

    const toast = useRef(null);

    // Esto es para el file upload
    const [totalSize, setTotalSize] = useState(0);

    const onTemplateSelect = (e) => {
        let _totalSize = totalSize;
        let files = e.files;

        Object.keys(files).forEach((key) => {
            _totalSize += files[key].size || 0;
        });

        setTotalSize(_totalSize);
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateUpload = (e) => {
        let _totalSize = 0;

        e.files.forEach((file) => {
            _totalSize += file.size || 0;
        });

        setTotalSize(_totalSize);
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSize / 10000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / 1 MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };


    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    const customBase64Uploader = async (event) => {

        // convert file to base64 encoded
        const file = event.files[0];
        /*const reader = new FileReader();
        let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            const base64data = reader.result;
            console.log(base64data);
        };*/
        console.log("file", file)
        let maxSizeFile = 10000000;
        
        if (file.size<=maxSizeFile){
            
            setMensajeError("");

            await genericaSistemaService.savefileUpload(idEmpresa, idioma, userName, props.guidDocument, props.tgRef, props.cgRef, file).then(response => {

                console.log("response, ",response, "props.metadataRef, ",props.metadataRef);
    
                props.onDocumentChange(response.genericasSistemaAffected, props.metadataRef);
    
            });

        }
        else{
            setMensajeError("Archivo supera el tamaño límite máximo de 10MG.");
            fileUploadRef.current.clear();
        }

    };

    const onUpload = () => {
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
    };

    let valRef = props.valRef;
    let apiUpload = process.env.NEXT_PUBLIC_URL_API + "/api/v1/GenericaSistema/uploadFile"
    let mensajeBase ="Archivos máximo de 10 MG.";
    //maxFileSize={10000000}
    return (
    <div style={{ width: '95%' }}>
        { mensajeError!=="" ? <Tag Tooltip="" className="mr-2" icon="pi pi-info-circle" severity="danger"  value={mensajeError}></Tag>  : <label>{mensajeBase}</label> }
        <FileUpload name="demo[]"  ref={fileUploadRef} mode="basic"
            customUpload uploadHandler={customBase64Uploader}  multiple={false} fileLimitMessage="Only 1 image" auto
            onUpload={onUpload} chooseLabel="Seleccionar"   uploadLabel='Subir' cancelLabel='Cancelar'               
            />

</div>
    );

    //cancelOptions={cancelOptions}

    //headerTemplate={headerTemplate} 
    //itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}

});

export default Document;
